export enum ConditionViewIndex {
  reviews = 0,
  overview = 1,
  acc32 = 2,
  visits = 3,
  discharges = 4
}
